import { FC } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import { useNavigate } from "react-router-dom";
import { TableFooterCommon } from "../../common/components/TableFooterCommon";
import { ButtonA } from "../../common/components/ButtonA";
import { EditButton } from "../../common/components/EditButton";
import { useParentCompaniesValue } from "../hooks/useParentCompaniesValue";

const tableCellHeadStyle = {
  fontWeight: 600,
};

type ParentCompanyTableProps = {
  page: number;
  rowsPerPage: number;
  totalRecords: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

export const ParentCompanyTable: FC<ParentCompanyTableProps> = ({
  page,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const navigate = useNavigate();
  const parentCompanies = useParentCompaniesValue();

  const handleNavigateToCreate = () => {
    navigate("/create-company");
  };

  return (
    <div className="mt-4">
      <div className="flex flex-row justify-end gap-4 pb-3">
        <ButtonA
          name={"Setup Company"}
          onHandleClick={handleNavigateToCreate}
        />
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="parent company table">
          <TableHead sx={{ backgroundColor: "#F5F4F4" }}>
            <TableRow>
              <TableCell sx={tableCellHeadStyle}>Company</TableCell>
              <TableCell sx={tableCellHeadStyle}>Organization</TableCell>
              <TableCell sx={tableCellHeadStyle}>Client Admin</TableCell>
              <TableCell sx={tableCellHeadStyle} align="center">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {parentCompanies.map((item: any) => (
              <TableRow key={item.id}>
                <TableCell width={"200"}>{item.companyName}</TableCell>
                <TableCell width={"250"}>
                  {item.organizations && item.organizations.length > 0
                    ? item.organizations.join(", ")
                    : "—"}
                </TableCell>
                <TableCell width={"250"}>
                  {item.clientAdmins && item.clientAdmins.length > 0
                    ? item.clientAdmins.join(", ")
                    : "—"}
                </TableCell>
                <TableCell width={"120"} align="center">
                  <EditButton
                    id={item.id}
                    onHandleEdit={(e) => {
                      e.stopPropagation();
                      navigate(`/update-company/${item.id}`);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

          <TableFooterCommon
            data={parentCompanies}
            rowsPerPage={rowsPerPage}
            page={page}
            totalRecords={totalRecords}
            onHandleChangePage={handleChangePage}
            onHandleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Table>
      </TableContainer>
    </div>
  );
};
